module["exports"] = ["Portugal"];